import { t as uiText } from '../i18n';
import React from 'react';

const menuItemStyle: React.CSSProperties = {
  padding: '8px 12px',
  cursor: 'pointer',
  fontSize: '14px',
  color: '#333',
  transition: 'background-color 0.2s',
};

export interface HomeMenuProps {
  open: boolean;
  onClose: () => void;
  isSelectionMode: boolean;
  onSelectionModeToggle: () => void;
  onOpenImport: () => void;
  isArchiveMode: boolean;
  onArchiveModeToggle: () => void;
  onOpenDeleteUntitled: () => void;
  onOpenBackup: () => void;
}

export function HomeMenu({
  open,
  onClose,
  isSelectionMode,
  onSelectionModeToggle,
  onOpenImport,
  isArchiveMode,
  onArchiveModeToggle,
  onOpenDeleteUntitled,
  onOpenBackup,
}: HomeMenuProps) {
  if (!open) return null;

  const handleMouseEnter = (e: React.MouseEvent<HTMLDivElement>) => {
    e.currentTarget.style.backgroundColor = '#f5f5f5';
  };
  const handleMouseLeave = (e: React.MouseEvent<HTMLDivElement>) => {
    e.currentTarget.style.backgroundColor = 'transparent';
  };

  return (
    <div
      style={{
        position: 'absolute',
        top: '100%',
        right: '0',
        backgroundColor: '#fff',
        boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
        borderRadius: '4px',
        minWidth: '200px',
        zIndex: 10000,
        marginTop: '4px',
      }}
    >
      <div
        onClick={() => {
          onClose();
          onSelectionModeToggle();
        }}
        style={{
          ...menuItemStyle,
          fontWeight: isSelectionMode ? 'bold' : 'normal',
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {isSelectionMode ? uiText("Clear page selection") : uiText("Select page")}
      </div>
      <div
        onClick={() => {
          onClose();
          onOpenImport();
        }}
        style={menuItemStyle}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {uiText("Upload page")}</div>
      <div
        onClick={() => {
          onClose();
          onArchiveModeToggle();
        }}
        style={{
          ...menuItemStyle,
          fontWeight: isArchiveMode ? 'bold' : 'normal',
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {isArchiveMode ? uiText("Show regular pages") : uiText("Show archived pages")}
      </div>
      <div
        onClick={() => {
          onClose();
          onOpenDeleteUntitled();
        }}
        style={menuItemStyle}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {uiText("Delete empty Memo pages")}</div>
      <div
        onClick={() => {
          onClose();
          onOpenBackup();
        }}
        style={menuItemStyle}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {uiText("Backups")}</div>
    </div>
  );
}
